export const IMAGE_CAPTURE_STEPS = {
    GLOBAL_CROWN: "global_crown",
    GLOBAL_LEFT: "global_left",
    GLOBAL_RIGHT: "global_right",
    IMAGE_UPLOAD: "image_upload", 
}

export const ROUTES = {
    LOGIN: "/login",
    STAFF_SELECT: "/staff-select",
    HOME: "/",
    PATIENT_SEARCH: "/patient-search",
    PATIENT_CREATE: "/patient-create",
    IMAGE_CAPTURE: {
        STATIC: "/image-capture/:id",
        DYNAMIC: (patientId) => `/image-capture/${patientId}`
    }
}